import { AccountType } from 'utils/api/models/accounts/singleAccount';

export type Bill = {
	billNo: number;
	paidAmount: number | null;
	unpaidAmount: number;
	date: string;
	daysTillPayment: number;
};

export type BillData = {
	billingId: number;
	bills: Bill[];
	totalUnpaid: number;
	accountType: AccountType;
};

export type Bills = {
	billsData: BillData[];
	totalUnpaid: number;
};

export type BillingRequest = {
	status?: BillingStatus;
	createdAt?: string;
	deleteAt?: string;
	periodMonth?: number;
	periodYear?: number;
};

export enum BillingStatus {
	PENDING = 'P',
	DELETED = 'D',
	NEW = 'N',
	READY = 'R',
	FAIL = 'F',
}

const model: types.models.InputModel = {
	billsData: 'response.getCustomerBillsForAccountsResponse.billsData',
	totalUnpaid: 'response.getCustomerBillsForAccountsResponse.totalUnpaid',
};

export default model;
